// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"383c5407","453":"f6c94965","556":"fa992e1e"}[chunkId] + ".chunk.js";
};